import { type WpOrderStatus, WP_ORDER_STATUS } from '@hooks-api/types/dataModel/eCommerceOrders'
import { type ShippingLabelProvider } from '@hooks-api/types/dataModel/fpOrder'
import { HStack } from '@pets-ui/HStack/HStack'
import { OpenInNew } from '@pets-ui/icons'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import * as stylex from '@stylexjs/stylex'
import { copyText } from '@utils'
import { useTranslation } from 'react-i18next'

const styles = stylex.create({
  openInNewLink: {
    alignItems: 'center',
    color: colors.grey600,
    display: 'flex',
    fontSize: 20,
  },
})

const TRACKING_URL_WITH_QUERY_MAP: Record<string, string> = {
  順豐: 'https://htm.sf-express.com/tw/tc/dynamic_function/waybill/#search/bill-number/',
  黑貓: 'https://www.t-cat.com.tw/Inquire/TraceDetail.aspx?BillID=',
}

interface TrackingShippingProps extends ShippingLabelProvider {
  status: WpOrderStatus

}

export function IconTrackingShipping(props: TrackingShippingProps) {
  const { t } = useTranslation()
  const { provider, shipping_labels, tracking_url, status } = props
  const isCancelledOrder = status === WP_ORDER_STATUS.CANCELLED

  if (isCancelledOrder) {
    return '-'
  }
  // @ts-expect-error - TODO: fix this
  if (!shipping_labels?.[0].tracking_no) return <Text color={colors.grey500}>{t('wpOrder.noTrackingNumber')}</Text>

  const tackingUrl = tracking_url
  const query = TRACKING_URL_WITH_QUERY_MAP[provider] ? `${TRACKING_URL_WITH_QUERY_MAP[provider]}${shipping_labels[0].tracking_no}` : null
  const trackingNo = shipping_labels[0].tracking_no
  const handleClickOpenInNew = () => {
    copyText(trackingNo)
    alert(t('wpOrder.copiedAlertContent'))
    window.open(tackingUrl, '_blank')
  }
  return (
    <HStack flexWrap="nowrap" gap={1} alignItems="center">
      <Text variant="caption">{trackingNo}</Text>
      {query
        ? (
          <a {...stylex.props(styles.openInNewLink)} href={query} rel="noopener noreferrer" target="_blank">
            <OpenInNew />
          </a>
        )
        : tackingUrl && <OpenInNew fontSize={20} onClick={handleClickOpenInNew} />}
    </HStack>
  )
}
